<section class="gb_sectionEstensioneAPersonale">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-lg-7">
        <div class="gb_textarea">
          <h2 class="gb_h3">{{ "estensione-area-personale" | translate }}</h2>
          <p class="gb_p">
            {{ "estensione-area-personale-messaggio" | translate }}
          </p>
          <a class="gb_btncta w u" [title]="'scopri-come' | translate" tabindex="0"
             [routerLink]="['/'+ this.storeService.codIpa, 'personal', 'extension-area']">
             {{ "scopri-come" | translate }}
          </a>
        </div>
      </div>
      <div class="col-12 col-lg-5">
        <img src="./assets/gb/img/logo-pap.svg" alt="Plug&Pay" width="451" height="293" aria-label="Plug&Pay"
             class="mw-image"/>
      </div>
    </div>
  </div>
</section>
